import PubSub from './pubsub';
export var getPubSub = function () {
    if (typeof window === 'undefined')
        return new PubSub();
    if (!window.KeenPubSub) {
        var pubsub = new PubSub();
        window.KeenPubSub = pubsub;
    }
    return window.KeenPubSub;
};
